import type { Localized } from '../../i18n'
import type { Tone } from '../../theme/tones'

/** Feed channels — shared by the list, the channel filter and the composer. */
export const CHANNEL_LABEL: Record<string, Localized> = {
  general: { ru: 'Общее', en: 'General' },
  it: { ru: 'IT', en: 'IT' },
  hr: { ru: 'HR', en: 'HR' },
  pr: { ru: 'PR', en: 'PR' },
  ideas: { ru: 'Идеи', en: 'Ideas' },
}

export const CHANNEL_TONE: Record<string, Tone> = {
  general: 'purple',
  it: 'blue',
  hr: 'green',
  pr: 'gold',
  ideas: 'red',
}

export const CHANNELS = Object.keys(CHANNEL_LABEL)
